module.exports = {
  Common: 'common',
  static: 'static',
  scan: 'scan',
  orderr: 'orderr',
  menus: 'menus',
};
